import { c as _c } from "react/compiler-runtime";
import { ReactElement, memo } from 'react';
import { formatDistanceToNow, parseISO } from 'date-fns';
import BazaarvoiceReviewFeedbackRowComponent from './bazaarvoice-review-feedback-row.component';
import { BazaarvoiceReviewPhoto } from './bazaarvoice-review-photo';
import BazaarvoiceReviewStarsComponent from './bazaarvoice-review-stars.component';
import ImageComponent from '../image-component/image.component';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import { ProductReview } from '@spa/generated/graphql/graphql';
import { createReviewPhotoDescriptionFactory } from './review-photo-description-factory';
import { de } from 'date-fns/locale';
import styles from './bazaarvoice-review-card.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
export interface Props {
  readonly review: ProductReview;
}
function BazaarvoiceReviewCardComponent(t0) {
  const $ = _c(52);
  const {
    review
  } = t0;
  const {
    formatMessage
  } = useNamespacedIntl("bazaarvoice-review-section");
  const {
    id,
    title,
    text,
    rating,
    submittedAt,
    userNickname,
    feedbackEligible,
    feedbackSummary,
    photos,
    syndicationSource
  } = review;
  const syndicationName = syndicationSource?.name ?? null;
  const syndicationLogoUrl = syndicationSource?.logoImageUrl ?? null;
  let t1;
  if ($[0] !== submittedAt) {
    t1 = submittedAt ? formatDistanceToNow(parseISO(submittedAt), {
      addSuffix: true,
      locale: de
    }) : null;
    $[0] = submittedAt;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const formattedDate = t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[2] !== formatMessage || $[3] !== formattedDate || $[4] !== photos || $[5] !== rating || $[6] !== text || $[7] !== title || $[8] !== userNickname) {
    const reviewPhotoDescriptionFactory = createReviewPhotoDescriptionFactory({
      formatMessage
    });
    t2 = styles["bazaarvoice-review-card"];
    let t8;
    if ($[15] !== formatMessage || $[16] !== rating) {
      t8 = formatMessage("reviewRatingAriaLabel", {
        rating
      });
      $[15] = formatMessage;
      $[16] = rating;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    let t9;
    if ($[18] !== rating) {
      t9 = <BazaarvoiceReviewStarsComponent filledStars={rating} starClassName={styles["bazaarvoice-review-card__star"]} />;
      $[18] = rating;
      $[19] = t9;
    } else {
      t9 = $[19];
    }
    if ($[20] !== t8 || $[21] !== t9) {
      t3 = <div className={styles["bazaarvoice-review-card__stars"]} role="img" aria-label={t8}>{t9}</div>;
      $[20] = t8;
      $[21] = t9;
      $[22] = t3;
    } else {
      t3 = $[22];
    }
    if ($[23] !== title) {
      t4 = <h4 className={styles["bazaarvoice-review-card__title"]}>{title}</h4>;
      $[23] = title;
      $[24] = t4;
    } else {
      t4 = $[24];
    }
    let t10;
    if ($[25] !== userNickname) {
      t10 = userNickname && <span className={styles["bazaarvoice-review-card__author"]}>{userNickname}</span>;
      $[25] = userNickname;
      $[26] = t10;
    } else {
      t10 = $[26];
    }
    let t11;
    if ($[27] !== formattedDate) {
      t11 = formattedDate && <span className={styles["bazaarvoice-review-card__date"]}>{formattedDate}</span>;
      $[27] = formattedDate;
      $[28] = t11;
    } else {
      t11 = $[28];
    }
    if ($[29] !== t10 || $[30] !== t11) {
      t5 = <div className={styles["bazaarvoice-review-card__meta"]}>{t10}{t11}</div>;
      $[29] = t10;
      $[30] = t11;
      $[31] = t5;
    } else {
      t5 = $[31];
    }
    if ($[32] !== text) {
      t6 = <p className={styles["bazaarvoice-review-card__text"]}>{text}</p>;
      $[32] = text;
      $[33] = t6;
    } else {
      t6 = $[33];
    }
    t7 = photos.length > 0 && <div className={styles["bazaarvoice-review-card__photos"]}>{photos.map((photo, index) => <BazaarvoiceReviewPhoto key={photo.id} photo={photo} description={reviewPhotoDescriptionFactory.getReviewPhotoDescription(photo, index, photos.length)} />)}</div>;
    $[2] = formatMessage;
    $[3] = formattedDate;
    $[4] = photos;
    $[5] = rating;
    $[6] = text;
    $[7] = title;
    $[8] = userNickname;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t2 = $[9];
    t3 = $[10];
    t4 = $[11];
    t5 = $[12];
    t6 = $[13];
    t7 = $[14];
  }
  let t8;
  if ($[34] !== formatMessage || $[35] !== syndicationLogoUrl || $[36] !== syndicationName) {
    t8 = (syndicationName || syndicationLogoUrl) && <div className={styles["bazaarvoice-review-card__syndication"]}>{syndicationLogoUrl && <ImageComponent src={syndicationLogoUrl} alt={syndicationName ?? formatMessage("syndicatedSourceLogoAlt")} width={80} height={24} className={styles["bazaarvoice-review-card__syndication-logo"]} />}{syndicationName && <span className={styles["bazaarvoice-review-card__syndication-name"]}>{formatMessage("syndicatedSourcePrefix")} {syndicationName}</span>}</div>;
    $[34] = formatMessage;
    $[35] = syndicationLogoUrl;
    $[36] = syndicationName;
    $[37] = t8;
  } else {
    t8 = $[37];
  }
  let t9;
  if ($[38] !== feedbackEligible || $[39] !== feedbackSummary.negativeCount || $[40] !== feedbackSummary.positiveCount || $[41] !== id) {
    t9 = <BazaarvoiceReviewFeedbackRowComponent reviewId={id} feedbackEligible={feedbackEligible} positiveCount={feedbackSummary.positiveCount} negativeCount={feedbackSummary.negativeCount} />;
    $[38] = feedbackEligible;
    $[39] = feedbackSummary.negativeCount;
    $[40] = feedbackSummary.positiveCount;
    $[41] = id;
    $[42] = t9;
  } else {
    t9 = $[42];
  }
  let t10;
  if ($[43] !== t2 || $[44] !== t3 || $[45] !== t4 || $[46] !== t5 || $[47] !== t6 || $[48] !== t7 || $[49] !== t8 || $[50] !== t9) {
    t10 = <article className={t2}>{t3}{t4}{t5}{t6}{t7}{t8}{t9}</article>;
    $[43] = t2;
    $[44] = t3;
    $[45] = t4;
    $[46] = t5;
    $[47] = t6;
    $[48] = t7;
    $[49] = t8;
    $[50] = t9;
    $[51] = t10;
  } else {
    t10 = $[51];
  }
  return t10;
}
export default memo(BazaarvoiceReviewCardComponent);